import { call, put, select } from 'redux-saga/effects';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';
import { removeApplication } from '../../../effects/organization';
import { setBannerAPIRequestState } from '../../../effects/message';
import AnalyticsService from '../../../../services/analytics.service';
import AnalyticsEvents from '../../../../services/analytics.constants';

export default function* deleteApplication(action) {
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const { uuid, name: appName } = yield select((state) =>
    state.organization.applications.content.find(
      (app) => action.payload.id === app.id,
    ),
  );
  const url = `${dpaApiBaseUrl + RESOURCES.V2}/applications/${
    action.payload.id
  }`;
  const { success, error } = yield call(callAPI, {
    url,
    method: METHODS.DELETE,
  });
  if (!error && success) {
    yield put(
      removeApplication({
        appId: action.payload.id,
      }),
    );
    yield put(
      setBannerAPIRequestState({
        bannerState: 'success',
        bannerMessage: 'Application has been successfully deleted!',
      }),
    );
    AnalyticsService.track(AnalyticsEvents.AppDeleted, {
      appName,
      uuid,
      appId: action.payload.id,
    });
  } else {
    console.error(error)
    yield put(
      setBannerAPIRequestState({
        bannerState: 'error',
        bannerMessage:
          'Something went wrong while deleting your application...',
      }),
    );
  }
}
